import { TickmillCompanyTypes } from '../api/Clients/Types/TickmillCompanyTypes'
import { TickmillCompanyDto } from '../api/Identity/Types/Company'

const TICKMILL_COMPANY_TYPES_TO_DISABLE = [
  TickmillCompanyTypes.Tickmill_EU_Company,
  TickmillCompanyTypes.Tickmill_UK_Company,
  TickmillCompanyTypes.Tickmill_Partners_Company,
]

export const isTickmillCompanyDisabled = (tickmillCompany: TickmillCompanyDto) =>
  TICKMILL_COMPANY_TYPES_TO_DISABLE.includes(tickmillCompany.id)
